import supabase from '../supabase/supabase';

// EXAKTER Tabellenname ohne Suffix
const TABLE_NAME = 'posts';

/**
 * Holt alle Beiträge aus Supabase.
 * @param {boolean} onlyPublished - Wenn true, werden nur veröffentlichte Beiträge geladen.
 */
export const getPosts = async (onlyPublished = true) => {
  try {
    let query = supabase
      .from(TABLE_NAME)
      .select('*')
      .order('date', { ascending: false });

    if (onlyPublished) {
      query = query.eq('is_published', true);
    }

    // Cache-Busting: Wir erzwingen eine frische Abfrage durch einen Zeitstempel-Header,
    // falls der Browser oder ein Proxy aggressiv cacht.
    const { data, error } = await query;
    
    if (error) {
      console.error('Supabase Fehler beim Laden der Posts:', error.message);
      return [];
    }
    
    return data || [];
  } catch (err) {
    console.error('Unerwarteter Fehler in getPosts:', err);
    return [];
  }
};

/**
 * Holt einen einzelnen Beitrag anhand des Slugs.
 */
export const getPostBySlug = async (slug) => {
  try {
    const { data, error } = await supabase
      .from(TABLE_NAME)
      .select('*')
      .eq('slug', slug)
      .single();

    if (error) {
      console.error(`Fehler beim Laden von Slug ${slug}:`, error.message);
      return null;
    }
    
    return data;
  } catch (err) {
    console.error('Unerwarteter Fehler in getPostBySlug:', err);
    return null;
  }
};

/**
 * Holt einen einzelnen Beitrag anhand der ID.
 */
export const getPostById = async (id) => {
  const { data, error } = await supabase
    .from(TABLE_NAME)
    .select('*')
    .eq('id', id)
    .single();

  if (error) return null;
  return data;
};

/**
 * Speichert oder aktualisiert einen Beitrag in Supabase.
 * KEIN LocalStorage Fallback mehr vorhanden.
 */
export const savePost = async (post) => {
  const postData = {
    title: post.title,
    slug: post.slug,
    description: post.description || post.teaser,
    content: post.content,
    category: post.category,
    focus_keyword: post.focus_keyword || post.keyword,
    read_time: post.read_time || '5',
    date: post.date || new Date().toISOString(),
    is_published: post.is_published !== undefined ? post.is_published : true,
    author: 'Marc Arndt' // Erzwungener Autor
  };

  if (post.id) {
    const { data, error } = await supabase
      .from(TABLE_NAME)
      .update(postData)
      .eq('id', post.id)
      .select();

    if (error) throw new Error(`Update fehlgeschlagen: ${error.message}`);
    return data[0];
  } else {
    const { data, error } = await supabase
      .from(TABLE_NAME)
      .insert([postData])
      .select();

    if (error) throw new Error(`Insert fehlgeschlagen: ${error.message}`);
    return data[0];
  }
};

/**
 * Löscht einen Beitrag.
 */
export const deletePost = async (id) => {
  const { error } = await supabase
    .from(TABLE_NAME)
    .delete()
    .eq('id', id);

  if (error) throw error;
  return true;
};